<div class="video-dialog">
  <iframe [src]="safeResourceUrl"
          width="800" height="450" frameborder="0"
          allow="autoplay; fullscreen; picture-in-picture"
          webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
</div>
